import { render, staticRenderFns } from "./materials_info.vue?vue&type=template&id=005ebd6f&scoped=true"
import script from "./materials_info.vue?vue&type=script&lang=js"
export * from "./materials_info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005ebd6f",
  null
  
)

export default component.exports